import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import { useFormik } from "formik";
import * as Yup from "yup";

const baseUrl = process.env.REACT_APP_BASE_URL;

const validationSchema = Yup.object({
    nameLat: Yup.string().required("Le nom est obligatoire")
});

const TierTypes = ({ title, category }) => {
    const [types, setTypes] = useState([]);
    const [form, setForm] = useState({
        id: 0,
        nameAr: "",
        nameLat: "",
        descriptionAr: "",
        descriptionLat: ""
    });
    const [selectedType, setSelectedType] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchTypes();
    }, [category]);

    const fetchTypes = () => {
        axiosInstance.get(`${baseUrl}/api/TierTypes/category/${category}`)
            .then(res => setTypes(res.data))
            .catch(() => console.log("Impossible de charger les types"))
            .finally(() => setLoading(false));
    };



    const formik = useFormik({
        initialValues: {
            id: 0,
            nameAr: "",
            nameLat: "",
            descriptionAr: "",
            descriptionLat: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { setErrors, resetForm }) => {

            const url = values.id
                ? `${baseUrl}/api/TierTypes/UpdateTierType`
                : `${baseUrl}/api/TierTypes/CreateTierType`;

            const payload = {
                ...values,
                id: parseInt(values.id, 10),
                category: category   // 🔹 spécifique TierTypes
            };

            try {
                await axiosInstance.post(url, payload);

                window.$("#modalForm").modal("hide");

                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Enregistrement effectué avec succès",
                    showConfirmButton: false,
                    timer: 2000,
                });

                fetchTypes();
                resetForm();
                setSelectedType(null);

            } catch (error) {

                // 🔴 erreurs serveur (ModelState / ServiceResponse)
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: "Opération échouée",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }
        }
    });

    const resetForm = () => {
        formik.resetForm();
        setSelectedType(null);
    };
    const handleEdit = (type) => {
        setSelectedType(type);
        formik.setValues(type);
        setTimeout(() => window.$("#modalForm").modal("show"), 100);
    };


    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/TierTypes/DeleteTierType`,
                    { 'id': id, 'idString': '' }).then(() => fetchTypes());
            }
        });
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">{title}</h3>

            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm" onClick={resetForm}><i className="fas fa-plus"></i>Ajouter</button>

            {loading ? (
                <p>Chargement...</p>
            ) : (
                <DataTableComponent
                    title={title}
                    columns={["nameLat", "descriptionLat"]}
                    columnsMapping={{
                        nameLat: "Nom",
                        descriptionLat: "Description",
                    }}
                    keyField="id"
                    data={types}
                    handleEdit={handleEdit}
                    handleDelete={(id) => handleDelete(id)}
                />
            )}

            <div className="modal fade" id="modalForm">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedType ? "Modifier" : "Ajouter"} un type</h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={resetForm}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Nom</label>
                                <input
                                    type="text"
                                    name="nameLat"
                                    className={`form-control ${formik.touched.nameLat && formik.errors.nameLat ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.nameLat}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.nameLat && formik.errors.nameLat && (
                                    <div className="invalid-feedback">
                                        {formik.errors.nameLat}
                                    </div>
                                )}                                <label>Description</label>
                                <input
                                    type="text"
                                    name="descriptionLat"
                                    className={`form-control ${formik.touched.descriptionLat && formik.errors.descriptionLat ? "is-invalid" : ""
                                        }`}
                                    value={formik.values.descriptionLat}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.descriptionLat && formik.errors.descriptionLat && (
                                    <div className="invalid-feedback">
                                        {formik.errors.descriptionLat}
                                    </div>
                                )}                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal" onClick={resetForm}>Annuler</button>
                            <button className="btn btn-primary" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TierTypes;
